import apiClient from '@/lib/api/client'
import type { Profile } from '@/types/auth'

export type AuthSessionUser = Pick<
  Profile,
  'id' | 'name' | 'email' | 'role' | 'is_active' | 'person_id' | 'craftsman_id' | 'created_at' | 'updated_at'
>

export type LoginRequest = {
  email: string
  password: string
}

export const authApi = {
  async login(payload: LoginRequest): Promise<AuthSessionUser> {
    const response = await apiClient.post<AuthSessionUser>('auth/login', payload)
    return response.data
  },

  async logout(): Promise<{ logged_out: boolean }> {
    const response = await apiClient.post<{ logged_out: boolean }>('auth/logout')
    return response.data
  },

  async getSession(): Promise<AuthSessionUser> {
    const response = await apiClient.get<AuthSessionUser>('auth/session')
    return response.data
  },
}
